import PageHeaderWrapper from "./PageHeaderWrapper";

export default PageHeaderWrapper;
